import React from "react";
import { SECTION_PADDING_STEPS, type SectionPadding } from "../lib/editor-content";

/** A step's pixel size: the spacing scale is 0.25rem = 4px per unit (tokens.css). */
const stepPx = (step: SectionPadding): number => step * 4;

const LAST = SECTION_PADDING_STEPS.length - 1;

/**
 * A slider over the spacing-scale steps, spaced evenly by index — the scale
 * spans 4px..256px, so proportional positions would crush the small steps
 * into the first few percent of the track. Labels show pixel equivalents.
 */
export function PaddingSlider({ value, onChange }: {
  value: SectionPadding;
  onChange: (value: SectionPadding) => void;
}) {
  const index = Math.max(0, SECTION_PADDING_STEPS.indexOf(value));

  return (
    <div className="space-y-1">
      <input
        type="range"
        min={0}
        max={LAST}
        step={1}
        value={index}
        onChange={(e) => onChange(SECTION_PADDING_STEPS[Number.parseInt(e.target.value, 10)])}
        className="w-full accent-primary"
        aria-label="Padding"
        aria-valuetext={`${stepPx(value)}px`}
      />
      {/* Labels are centred on each stop; the 8px end insets keep the first and
          last labels inside the panel (roughly matching the thumb's own travel). */}
      <div className="relative h-4">
        {SECTION_PADDING_STEPS.map((step, i) => (
          <span
            key={step}
            className={`absolute -translate-x-1/2 text-[9px] tabular-nums ${
              step === value ? "font-semibold text-foreground" : "text-muted-foreground"
            }`}
            style={{ left: `calc(8px + (100% - 16px) * ${(i / LAST).toFixed(4)})` }}
          >
            {stepPx(step)}
          </span>
        ))}
      </div>
    </div>
  );
}
